import { render } from "./PacienteCreate.vue?vue&type=template&id=f2ee68a2&scoped=true"
import script from "./PacienteCreate.vue?vue&type=script&lang=js"
export * from "./PacienteCreate.vue?vue&type=script&lang=js"

import "./PacienteCreate.vue?vue&type=style&index=0&id=f2ee68a2&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ee68a2"]])

export default __exports__